import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { AuthContext } from '../App';

// Routes that are full-screen / interactive where a fixed footer would overlap content.
const HIDE_PREFIXES = [
  '/chat/',
  '/voice/',
  '/call/',
  '/mobile-chat/',
  '/mobile-voice-call/',
  '/mobile-video-call/',
];

export const AppFooter = () => {
  const { pathname } = useLocation();
  const auth = useContext(AuthContext) || {};
  const hidden = HIDE_PREFIXES.some((p) => pathname.startsWith(p));
  if (hidden) return null;

  return (
    <footer
      data-testid="app-footer"
      className="fixed bottom-0 inset-x-0 z-40 pointer-events-none py-1.5 text-center"
    >
      <span className="inline-flex items-center gap-2 text-[11px] tracking-wide text-gray-400 bg-white/70 backdrop-blur-sm px-3 py-0.5 rounded-full">
        <span>Powered by My Counsellor Online</span>
        <span aria-hidden="true">·</span>
        <a
          href={process.env.REACT_APP_PRIVACY_URL || '#'}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-privacy-link"
          className="pointer-events-auto underline hover:text-gray-600 transition-colors"
        >
          Privacy
        </a>
        {auth.user && (
          <>
            <span aria-hidden="true">·</span>
            <Link
              to="/privacy-requests"
              data-testid="footer-mydata-link"
              className="pointer-events-auto underline hover:text-gray-600 transition-colors"
            >
              My Data
            </Link>
          </>
        )}
      </span>
    </footer>
  );
};

export default AppFooter;
